import React from 'react';
export function TransformTable() {
  const models = [{
    letter: 'A',
    cat: 'Modelo 1 · Contenido Sintético',
    title: 'FACTORÍA DE CONTENIDO IA',
    desc: 'Produce contenido viral para marcas y negocios a escala industrial. Tú entregas en horas lo que una agencia tarda semanas.',
    earning: '$500 — $2,000 / mes'
  }, {
    letter: 'B',
    cat: 'Modelo 2 · Diseño de Autoridad',
    title: 'AGENCIA UI/UX CON IA',
    desc: 'Rediseña webs y landing pages de negocios usando IA para crear interfaces de nivel Silicon Valley. En una tarde entregas algo que vale $3,000.',
    earning: '$1,500 — $5,000 / proyecto'
  }, {
    letter: 'C',
    cat: 'Modelo 3 · Ingeniería Sintética',
    title: 'CONSTRUCTOR DE MICRO-SAAS',
    desc: 'Construye herramientas web y aplicaciones para empresas usando IA. Un solo cliente puede pagarte $300/mes por años.',
    earning: '$300 — $1,000 / cliente / mes'
  }];
  return <section className="py-8 md:py-[120px] px-4 md:px-12 relative z-10 bg-gradient-to-b from-transparent via-gold-soft to-transparent" aria-label="Modelos de Monetización" data-id="element-278">
      <div className="max-w-[1100px] mx-auto" data-id="element-279">
        <div className="mb-8 md:mb-20" data-id="element-280">
          <span className="section-tag" data-id="element-281">Modelos de Negocio</span>
          <h2 className="font-display text-[clamp(2.2rem,5vw,5rem)] tracking-[3px] leading-none mb-4 md:mb-6" data-id="element-282">
            DEJA DE VENDER
            <br data-id="element-283" />
            <span className="text-gold" data-id="element-284">SERVICIOS.</span>
            <br data-id="element-285" />
            VENDE ACTIVOS.
          </h2>
          <p className="font-text text-[0.88rem] md:text-[1.05rem] text-text-silver max-w-[580px] leading-[1.6]" data-id="element-286">
            Tres modelos de negocio probados para cobrar en dólares o euros
            desde cualquier ciudad del mundo.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-287">
          {models.map((m, idx) => <div key={idx} className="bg-bg-card border border-border rounded-xl p-5 md:p-10 transition-all duration-[350ms] relative overflow-hidden group hover:border-border-glow hover:-translate-y-1.5 hover:shadow-[0_32px_64px_rgba(255,215,0,0.06)]" data-id="element-288">
              <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" data-id="element-289" />
              <div className="font-display text-[3.5rem] md:text-[5rem] text-gold/[0.06] leading-none mb-3 md:mb-6" aria-hidden="true" data-id="element-290">
                {m.letter}
              </div>
              <div className="text-[0.6rem] md:text-[0.65rem] tracking-[3px] uppercase text-cyan mb-2" data-id="element-291">
                {m.cat}
              </div>
              <h3 className="font-display text-[1.4rem] md:text-[1.8rem] tracking-[2px] leading-[1.1] mb-3 md:mb-4" data-id="element-292">
                {m.title}
              </h3>
              <p className="text-[0.8rem] md:text-[0.9rem] text-text-silver leading-[1.6] mb-4 md:mb-6" data-id="element-293">
                {m.desc}
              </p>
              <div className="inline-flex items-center gap-2 bg-gold-soft border border-border-glow px-4 md:px-5 py-2 rounded-md font-display text-[1rem] md:text-[1.2rem] text-gold tracking-[2px]" aria-label="Ingreso potencial" data-id="element-294">
                💰 {m.earning}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}